export const config = {
    nextRacesCount: 3
};
//# sourceMappingURL=config.js.map